<template>
  <!--Legende -->
  <div
    class="fixed right-0 z-50 w-64 p-0 mt-4 transition-all duration-500 shadow-lg bg-base-100 card top-32 2xl:w-96"
    :class="{
      'translate-x-[calc(100%-2rem)] h-40 ': !openLegend,
      'translate-x-0 max-h-[calc(100vh-22rem)]': openLegend
    }"
  >
    <div
      :class="{
        'opacity-0 pointer-events-none': openLegend,
        'opacity-100 pointer-events-auto': !openLegend
      }"
      @click="openLegend = !openLegend"
      class="absolute flex items-center justify-between h-full py-4 text-2xl font-bold rotate-180 text-secondary-content bg-secondary"
      style="writing-mode: vertical-rl; text-orientation: mixed"
    >
      <span>Legende</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-6 h-6 scale-100 -rotate-90 cursor-pointer animate-pulse hover:scale-110 hover:animate-none"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 13l-7 7-7-7m14-8l-7 7-7-7"
        />
      </svg>
    </div>
    <div
      @click="openLegend = !openLegend"
      class="flex items-center justify-between px-2 py-1 text-2xl font-bold gap-x-4 card-title bg-secondary text-secondary-content"
    >
      <span>Legende</span>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-6 h-6 scale-100 cursor-pointer animate-pulse hover:scale-110 hover:animate-none"
        :class="{ '-rotate-90': openLegend, 'rotate-180': !openLegend }"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 13l-7 7-7-7m14-8l-7 7-7-7"
        />
      </svg>
    </div>
    <div class="h-full p-0 overflow-auto card-body">
      <div
        ref="legend"
        class="flex flex-col px-4 py-2 transition-all duration-100 delay-0 gap-y-1"
      >
        <div class="flex items-center gap-x-2">
          <div
            class="flex items-center justify-center w-8 h-8 text-xs text-center rounded-full bg-secondary text-secondary-content"
          >
            +2
          </div>
          <span>Superposition</span>
        </div>
        <div class="flex items-center gap-x-2">
          <div
            class="flex items-center justify-center w-8 h-8 text-xs text-center rounded-full bg-primary text-primary-content"
          >
            A1
          </div>
          <span>Activité</span>
        </div>

        <h1 class="mt-2 font-bold text-secondary">Zones d'actions</h1>
        <div class="flex items-center mt-2 gap-x-2">
          <div
            class="flex items-center justify-center w-8 h-8 text-xs text-center bg-green-500 text-accent-content"
          ></div>
          <span>Critique</span>
        </div>

        <div class="flex items-center gap-x-2">
          <div
            class="flex items-center justify-center w-8 h-8 text-xs text-center bg-blue-500 text-accent-content"
          ></div>
          <span>Élévé</span>
        </div>

        <div class="flex items-center gap-x-2">
          <div
            class="flex items-center justify-center w-8 h-8 text-xs text-center bg-yellow-500 text-accent-content"
          ></div>
          <span>Préoccupant</span>
        </div>

        <div class="flex items-center gap-x-2">
          <div
            class="flex items-center justify-center w-8 h-8 text-xs text-center bg-rouge text-accent-content"
          ></div>
          <span>Faible</span>
        </div>
      </div>
    </div>
    <div class="p-4">
      <a
        class="z-[99999] mx-auto btn btn-sm btn-primary"
        @click="$emit('download')"
        >Editer le rapport<i class="ml-1 fas fa-file-pdf"></i
      ></a>
    </div>
  </div>
  <!-- Fin  Legende -->
</template>

<script>
export default {
  name: "MPLegend",
  data() {
    return {
      openLegend: false
    };
  },
  methods: {
    getLengendElement() {
      return this.$refs.legend;
    }
  }
};
</script>

<style></style>
